export const FacebookCrmTypeDecorator = {
  url() {
    return `signup-hubspot/integrations`;
  },
  query() {
    return {
      integration: 'fb-crm'
    };
  }
};